(function () {
  //Remove the view transition render blocker if the user has reduced motion enabled
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');
    if (viewTransitionRenderBlocker) viewTransitionRenderBlocker.remove();
  }

  // Desabilita restauração automática do browser no Safari para evitar conflito
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  const idleCallback = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;

  const SCROLL_RESTORE_KEY = 'view-transition-scroll-restore';

  function scrollRestoreKey() {
    // Remove variant parameter from key para evitar conflito quando variante muda
    const url = new URL(location.href);
    url.searchParams.delete('variant');
    return SCROLL_RESTORE_KEY + '_' + (url.pathname || '/') + (url.search || '');
  }

  function saveScrollForRestore() {
    try {
      sessionStorage.setItem(scrollRestoreKey(), String(window.scrollY || 0));
    } catch (_) {}
  }

  // Flag para evitar múltiplas restaurações de scroll simultâneas
  let isRestoringScroll = false;
  let hasRestoredScroll = false; // Flag global para evitar restauração duplicada entre pagereveal e pageshow

  function restoreScrollAndClear() {
    if (isRestoringScroll || hasRestoredScroll) return; // Evita scroll duplicado
    
    try {
      // Se houver hash na URL, não restaura (deixa o código de hash lidar)
      if (location.hash) {
        hasRestoredScroll = true; // Marca para evitar execução duplicada
        return;
      }
      
      const key = scrollRestoreKey();
      const v = sessionStorage.getItem(key);
      if (v == null) {
        hasRestoredScroll = true; // Não há valor salvo, marca para evitar tentativas futuras
        return;
      }
      
      const y = parseInt(v, 10);
      if (!Number.isFinite(y) || y <= 0) {
        sessionStorage.removeItem(key);
        hasRestoredScroll = true;
        return;
      }
      
      // Verifica se já está próximo da posição salva (evita scroll desnecessário)
      const currentY = window.scrollY || 0;
      const diff = Math.abs(currentY - y);
      if (diff < 50) { // Se já está a menos de 50px da posição, não restaura
        sessionStorage.removeItem(key);
        hasRestoredScroll = true;
        return;
      }
      
      // Se houver variante na URL, aguarda um pouco mais para dar tempo à atualização da variante
      const hasVariant = new URLSearchParams(location.search).has('variant');
      const delay = hasVariant ? 100 : 0; // Pequeno delay se houver variante
      
      isRestoringScroll = true;
      hasRestoredScroll = true;
      sessionStorage.removeItem(key);
      
      // Usa requestAnimationFrame para coordenar, com delay adicional se houver variante
      setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            window.scrollTo(0, y);
            setTimeout(() => {
              isRestoringScroll = false;
            }, 50);
          });
        });
      }, delay);
    } catch (_) {
      isRestoringScroll = false;
    }
  }

  /**
   * @param {PageSwapEvent} event
   */
  window.addEventListener('pageswap', async (event) => {
    if (!hasViewTransition(event)) return;

    // Reseta flag ao sair da página para permitir restauração na próxima visita
    hasRestoredScroll = false;
    saveScrollForRestore();

    const { viewTransition } = event;

    // Cancel view transition on user interaction to improve INP (Interaction to Next Paint)
    ['pointerdown', 'keydown'].forEach(eventName => {
      document.addEventListener(eventName, () => {
        viewTransition.skipTransition();
      }, { once: true });
    });

    // Clean in case you landed on the pdp first. We want to remove the default transition type on the PDP media gallery so there is no duplicate transition name
    document
      .querySelectorAll('[data-view-transition-type]:not([data-view-transition-triggered])')
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector('[data-view-transition-triggered]');
    const transitionType = transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem('custom-transition-type', transitionType);
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  /**
   * @param {PageRevealEvent} event
   */
  window.addEventListener('pagereveal', async (event) => {
    if (!hasViewTransition(event)) return;

    const { viewTransition } = event;

    // Restaura a posição de scroll depois da transição (corrige Safari iPad que vai para o topo ao voltar)
    // Usa apenas requestAnimationFrame para coordenar após a transição terminar
    viewTransition.finished.then(() => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          restoreScrollAndClear();
        });
      });
    });

    const customTransitionType = sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');
        document.querySelectorAll('[data-view-transition-type]').forEach((element) => {
          element.removeAttribute('data-view-transition-type');
        });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  /**
   * Checks whether an Event object is carrying a `viewTransition` property
   * (as used by the View Transition API) and narrows the type accordingly.
   *
   * @template {Event} T
   * @param {T} event
   * @returns {event is T & { viewTransition: ViewTransition }}
   */
  function hasViewTransition(event) {
    return 'viewTransition' in event && event.viewTransition instanceof ViewTransition;
  }

  // Fallback: ao voltar via bfcache (ex.: Safari iPad), pagereveal pode não disparar; restaura em pageshow.
  // Mas só executa se pagereveal não tiver executado (evita duplo loading)
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) {
      // Reseta flag em navegação normal (não bfcache)
      hasRestoredScroll = false;
      return;
    }
    // Pequeno delay apenas para verificar se pagereveal já executou
    setTimeout(() => {
      // Se pagereveal já executou, não executa aqui (evita duplo loading)
      if (!hasRestoredScroll) {
        requestAnimationFrame(() => {
          requestAnimationFrame(restoreScrollAndClear);
        });
      }
    }, 0);
  });
})();
